/** break and adds ... at a word break that exceeds the allowed length */
const truncate = (str, { length = 86, breakWord } = {}) => {
  if (!str) return str;
  if (str.length <= length) return str;
  let revisedLength = length;
  if (breakWord) return `${str.slice(0, revisedLength)}...`;
  while (str[revisedLength] && str[revisedLength] !== " ") {
    revisedLength++;
  }
  return `${str.slice(0, revisedLength)}...`;
};

export default truncate;
